import React from 'react'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'

import Overlay from '../components/Overlay'
import Form from '../components/ContacsForm'

const ContactsPage = ({ data, fetching, formOpened, setFormState }) => (
  <div>
    <div className='Contacts'>
      <div className='Container Container_light'>
        <h1 className='Head Contacts__title'>
          <FormattedMessage id='contacts.address' />
        </h1>
        <div className='Row Contacs__Row'>
          <div className='Contacts__col'>
            {data.email &&
              <div className='Contacts__row'>
                <p className='Text'>
                  <FormattedMessage id='contacts.phone' />
                  <br /><a href={`tel:+7 999 996‑26‑84`} className='Link_black'>+7 999 996‑26‑84</a>
                  <p className='Text'></p>
                  <FormattedMessage id='contacts.coop_questions' />
                  <br /><a href={`mailto:apopova@meetforcharity.today`} className='Link_black'>apopova@meetforcharity.today</a>
                  <p className='Text'></p>  
                  <FormattedMessage id='contacts.funds_questions' />
                  <br /><a href={`mailto:funds@meetforcharity.today`} className='Link_black'>funds@meetforcharity.today</a>
                  <p className='Text'></p>
                  <FormattedMessage id='contacts.lot_questions' />
                  <br />
                    <a href='https://t.me/meetingsMFC' className='Link_black'> @meetingsMFC</a>,
                    <a href='https://t.me/meet_for_charity' className='Link_black'>@meet_for_charity</a>,
                    <a href={`mailto:meet@meetforcharity.today`} className='Link_black'> meet@meetforcharity.today</a>
                  <p className='Text'></p>
                  <FormattedMessage id='contacts.lot_offer' />
                  <br /><a href={`mailto:apopova@meetforcharity.today`} className='Link_black'>apopova@meetforcharity.today</a>
                  <p className='Text'></p>   


                </p>
              </div>
            }
            <div className='Contacts__row'>
              <p className='Text'>
                <FormattedMessage id='contacts.we_are_on' />
                {' '}
                {/* <a href={data.facebook} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.facebook' />
                </a>
                {', '}
                <a href={data.instagram} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.instagram' />
                </a>
                {' '}
                <FormattedMessage id='common.and' />
                &nbsp; */}
                <a href={data.youtube} target='_blank' className='Link'>
                  <FormattedMessage id='contacts.youtube' />
                </a>
              </p>
            </div>
          </div>
          <div className='Contacts__col'>
            <p className='Text Contacts__text'>
              <FormattedMessage id='contacts.if_you_have' />
            </p>
            <button className='Button Button_white' onClick={e => setFormState(true)}>
              <FormattedMessage id='contacts.write' />
            </button>
          </div>
        </div>
      </div>
    </div>

    <Overlay isActive={formOpened} onClose={e => setFormState(false)}>
      <Form />
    </Overlay>
  </div>
)

const mapStateToProps = state => ({
  ...state.contacts,
  currentLocale: state.intl.locale
})
export default compose(
  connect(mapStateToProps),
  withState('formOpened', 'setFormState', false)
)(ContactsPage)



// WEBPACK FOOTER //
// ./src/containers/Contacts.jsx